import React from "react";
import { Modal } from "antd";
import Button from "../../components/Button";
import { useDispatch,useSelector } from 'react-redux'
import { setAddMemoriesModal, setMemoriesViewMOdal } from "../../actions/MemoriesActions";
import AddMemoryForm from "./AddMemoryForm";

const FilterForm = () => {
    const dispatch=useDispatch();
    const memoryState=useSelector((state)=>state?.memoryState);

    const onAddMemory = () =>{
        dispatch(setAddMemoriesModal(true))
    }



  return (<>
    <div style={{ marginBottom: 16, float:"right" }}>
        <div onClick={onAddMemory}>
              <Button label="Add Memory" />
            </div>
    </div>   
 </> );
};

export default FilterForm; 